export namespace Constants {
    export const POLICY_TYPE = {
      GROUP: 'GROUP',
      INDIVIDUAL: 'INDIVIDUAL'
    };
    export const ROLES = {
      OWNER: 'OWNER',
      NOMINEE: 'NOMINEE',
      PAYER: 'PAYER',
      ASSIGNEE: 'ASSIGNEE',
      APPOINTEE: 'APPOINTEE',
      PRIMARYINSURED: 'PRIMARYINSURED',
      INSURED: 'INSURED',
      BENEFICIARY: 'BENEFICIARY',
      CLAIMANT: 'CLAIMANT',
      PAYEE: 'PAYEE',
      DEPENDENT: 'DEPENDENT'
    };
    export const CLAIM_EVENT_TYPE = {
      DEATH : 'DEATH'
    };
  
    export const DEATH_EVENT = {
    PLACE_OF_DEATH_OTHER : 'OTHERS'
    };
  }